export default __webpack_public_path__ + "static/media/widget_watchbox_vpmspx1_sell.739d901c.mp3";